import { render, staticRenderFns } from "./MyParametricDemo.vue?vue&type=template&id=e643b83a&"
import script from "./MyParametricDemo.vue?vue&type=script&lang=js&"
export * from "./MyParametricDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports